export interface BibleTranslation {
    id: string;
    name: string;
    copyrightHtml: string;
}

export const SupportedTranslations: BibleTranslation[] = [
    {
        id: "AMP",
        name: "Amplified© Bible",
        copyrightHtml: `
            Copyright © 2015 by The Lockman Foundation, La Habra, CA 90631. All rights reserved. For Permission To Quote information visit <a href="http://www.lockman.org/">http://www.lockman.org/</a>
            <br />
            The "Amplified" trademark is registered in the United States Patent and Trademark Office by The Lockman Foundation. Use of this trademark requires the permission of The Lockman Foundation.`
    },
    {
        id: "ASV",
        name: "American Standard Version",
        copyrightHtml: `The American Standard Version of the Holy Bible, first published in 1901. Public Domain.`
    },
    {
        id: "DBY",
        name: "Darby Translation",
        copyrightHtml: `The Holy Scriptures, a New Translation from the Original Languages by J. N. Darby. Public Domain.`
    },
    {
        id: "ERV",
        name: "English Revised Version",
        copyrightHtml: `The Revised Version of the Holy Bible (1895) with Apocrypha. Public Domain.`
    },
    {
        id: "ESV",
        name: "English Standard Version",
        copyrightHtml: `The Holy Bible, English Standard Version. ESV® Text Edition: 2016. Copyright © 2001 by <a href="https://www.crossway.org/">Crossway Bibles</a>, a publishing ministry of Good News Publishers.`
    },
    {
        id: "KJV",
        name: "King James Version",
        copyrightHtml: `The King James Version or Authorized Version of the Holy Bible, using the standardized text of 1769, with Apocrypha/Deuterocanon. Public Domain.`
    },
    {
        id: "LBLA",
        name: "La Biblia de Las Américas",
        copyrightHtml: `LA BIBLIA DE LAS AMERICAS®, Copyright © 1986, 1995, 1997 by The Lockman Foundation. Used by permission.`
    },
    {
        id: "MSG",
        name: "The Message",
        copyrightHtml: `Copyright © 1993, 1994, 1995, 1996, 2000, 2001, 2002. Used by permission of NavPress Publishing Group.`
    },
    {
        id: "NASB",
        name: "New American Standard Bible",
        copyrightHtml: `NEW AMERICAN STANDARD BIBLE®, Copyright © 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995 by The Lockman Foundation. Used by permission.`
    },
    {
        id: "NBL",
        name: "Nueva Biblia Latinoamericana",
        copyrightHtml: `
        <div class="copyright">
            LA BIBLIA DE LAS AMERICAS®, Copyright © 1986, 1995, 1997 by The Lockman Foundation. Used by permission.
        </div>`
    },
    {
        id: "NIRV",
        name: "New International Reader's Version",
        copyrightHtml: `
        <div class="copyright">
            THE HOLY BIBLE, NEW INTERNATIONAL READER'S VERSION®, NIrV® Copyright © 1995, 1996, 1998, 2014 by Biblica, Inc.® Used by permission. All rights reserved worldwide.
        </div>`
    },
    {
        id: "NIV",
        name: "New International Version",
        copyrightHtml: `
        <div class="copyright">
            THE HOLY BIBLE, NEW INTERNATIONAL VERSION®, NIV® Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.® Used by permission. All rights reserved worldwide.
        </div>`
    },
    {
        id: "NLT",
        name: "New Living Translation",
        copyrightHtml: `<em>Holy Bible</em>, New Living Translation, copyright © 1996, 2004, 2015 by Tyndale House Foundation. Used by permission of Tyndale House Publishers, Inc., Carol Stream, Illinois 60188. All rights reserved.`
    },
    {
        id: "OJB",
        name: "Orthodox Jewish Bible",
        copyrightHtml: `The Orthodox Jewish Bible fourth edition, OJB. Copyright 2002, 2003, 2008, 2010, 2011 by Artists for Israel International. All rights reserved.`
    },
    {
        id: "WEB",
        name: "World English Bible",
        copyrightHtml: `The World English Bible is in the Public Domain. That means that it is not copyrighted. However, "World English Bible" is a Trademark of eBible.org.`
    },
    {
        id: "YLT",
        name: "Young's Literal Translation",
        copyrightHtml: `Young's Literal Translation of the Holy Bible by Robert Young. Published in 1862. Public Domain.`
    },
    
];